import Image from "next/image";

import type { StoryBlokMedia } from "@/types/storyblok";

import styles from "./sb-image.module.css";
import { fill } from "pdf-lib";

type StoryBlokImageProps = {
  media: StoryBlokMedia;
} & StoryblokImageSizes;

type StoryblokImageSizes =
  | {
      fill?: false;
      sizes?: string;
      width: number | `${number}`;
      height: number | `${number}`;
      customAspect?: boolean;
    }
  | {
      fill: true;
      sizes: string;
      width: undefined;
      height: undefined;
      customAspect?: boolean;
    };

const StoryblokImage = ({
  media,
  width,
  height,
  sizes,
  fill,
  customAspect,
}: StoryBlokImageProps): React.JSX.Element => (
  <Image
    src={media.file}
    alt={media.alt}
    fill={fill}
    width={width}
    height={height}
    className={styles.image}
    sizes={sizes}
    style={{
      objectPosition: media.focus,
      aspectRatio: !customAspect ? `${media.width}/${media.height}` : undefined,
    }}
  />
);

export default StoryblokImage;
